import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/images/logo-m.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "menu" }
const _hoisted_3 = { class: "link-list" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "dot" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "dot" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "dot" }, null, -1)
const _hoisted_7 = { class: "link-item l3" }
const _hoisted_8 = {
  href: "https://www.artube.video/",
  target: "_blank"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "dot" }, null, -1)
const _hoisted_10 = { class: "link-item l6" }
const _hoisted_11 = {
  href: "https://market.artube.video",
  target: "_blank"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "dot" }, null, -1)
const _hoisted_13 = { class: "link-item l5" }
const _hoisted_14 = {
  href: "https://www.artube.video/whitepaper.html",
  target: "_blank"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "dot" }, null, -1)
const _hoisted_16 = { class: "link-item" }
const _hoisted_17 = { class: "dropdown-language" }
const _hoisted_18 = { class: "select" }
const _hoisted_19 = {
  class: "for-dropdown",
  for: "currLang"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-down" }, null, -1)
const _hoisted_21 = { class: "section-dropdown" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-wallet" }, null, -1)
const _hoisted_24 = {
  key: 0,
  class: "address-text"
}
const _hoisted_25 = {
  key: 1,
  class: "address-text"
}
const _hoisted_26 = { class: "icon icon-wallet-down" }
const _hoisted_27 = { class: "wallet-inner" }
const _hoisted_28 = { class: "wallet-inner-top" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-wallet2" }, null, -1)
const _hoisted_30 = { class: "wallet-inner-network" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "wallet-inner-etc" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-copy" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-view-more" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-exit" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_37 = { id: "mb-header-wrap" }
const _hoisted_38 = { class: "mb-header-inner" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { for: "menuicon" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_40 = { class: "mb-list" }
const _hoisted_41 = {
  href: "https://www.artube.video/",
  target: "_blank"
}
const _hoisted_42 = {
  href: "https://market.artube.video",
  target: "_blank"
}
const _hoisted_43 = {
  href: "https://www.artube.video/whitepaper.html",
  target: "_blank"
}
const _hoisted_44 = { class: "lang-list-box" }
const _hoisted_45 = { class: "dropdown-language mb" }
const _hoisted_46 = { class: "mb-lang-box select" }
const _hoisted_47 = {
  for: "currLang2",
  class: "for-dropdown mb"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-down" }, null, -1)
const _hoisted_49 = { class: "section-dropdown" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "link-item wallet-area mb" }
const _hoisted_52 = { style: {"text-overflow":"ellipsis"} }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-wallet" }, null, -1)
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopupOk = _resolveComponent("PopupOk")!
  const _directive_clipboard = _resolveDirective("clipboard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["header", [_ctx.router.currentRoute.path === '/' ? 'main' : '', _ctx.initIsBlack ? 'back' : '']])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", {
          class: "logo",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickLogo()))
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("ul", _hoisted_3, [
            _createElementVNode("li", {
              class: _normalizeClass(["link-item l1", [_ctx.router.currentRoute.path === '/agenda' ? 'on' : '', _ctx.router.currentRoute.path === '/agendadetail' ? 'on' : '']]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.connectChecked('/agenda')))
            }, [
              _createElementVNode("a", null, [
                _createTextVNode(_toDisplayString(_ctx.$t("detail.voting")) + " ", 1),
                _hoisted_4
              ])
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(["link-item l2", _ctx.router.currentRoute.path === '/staking' ? 'on' : '']),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.connectChecked('/staking')))
            }, [
              _createElementVNode("a", null, [
                _createTextVNode(_toDisplayString(_ctx.$t("staking.staking")) + " ", 1),
                _hoisted_5
              ])
            ], 2),
            _createElementVNode("li", {
              class: "link-item l7",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.router.push('/forum')))
            }, [
              _createElementVNode("a", null, [
                _createTextVNode(_toDisplayString(_ctx.$t("header.forum")) + " ", 1),
                _hoisted_6
              ])
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createElementVNode("a", _hoisted_8, [
                _createTextVNode(_toDisplayString(_ctx.$t("header.webtoon")) + " ", 1),
                _hoisted_9
              ])
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createElementVNode("a", _hoisted_11, [
                _createTextVNode(_toDisplayString(_ctx.$t("header.nft-market")) + " ", 1),
                _hoisted_12
              ])
            ]),
            _createElementVNode("li", _hoisted_13, [
              _createElementVNode("a", _hoisted_14, [
                _createTextVNode(_toDisplayString(_ctx.$t("header.docs")) + " ", 1),
                _hoisted_15
              ])
            ]),
            _createElementVNode("li", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    class: "dropdown",
                    type: "checkbox",
                    id: "currLang",
                    name: "currLang",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.foldLang) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.foldLang]
                  ]),
                  _createElementVNode("label", _hoisted_19, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.currentLanguage), 1),
                    _hoisted_20
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langs, (item, index) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: index,
                        onClick: ($event: any) => (_ctx.changeLanguage(item)),
                        class: _normalizeClass({ active: item.title === _ctx.currentLanguage })
                      }, _toDisplayString(item.title), 11, _hoisted_22))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("li", {
              class: "link-item wallet-area",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.connectMetaMask()))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["wallet", { wrong: _ctx.isWalletType === 1 }])
              }, [
                _hoisted_23,
                (_ctx.store.state.address === '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Connect"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.store.getters.getAddressEllipsis), 1)),
                _withDirectives(_createElementVNode("i", _hoisted_26, null, 512), [
                  [_vShow, _ctx.store.state.isConnected]
                ])
              ], 2),
              _withDirectives(_createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("p", null, [
                    _hoisted_29,
                    _createElementVNode("span", null, _toDisplayString(_ctx.store.getters.getAddressEllipsis), 1)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("header.network")), 1),
                    (_ctx.store.state.metaMask)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(_ctx.store.state.metaMask.networkName), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("ul", _hoisted_32, [
                  _withDirectives((_openBlock(), _createElementBlock("li", null, [
                    _hoisted_33,
                    _createTextVNode(_toDisplayString(_ctx.$t("header.copy-address")), 1)
                  ])), [
                    [_directive_clipboard, _ctx.store.state.address, "copy"],
                    [_directive_clipboard, _ctx.onCopySuccess, "success"],
                    [_directive_clipboard, _ctx.onCopyError, "error"]
                  ]),
                  _createElementVNode("li", {
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.viewOnExplorer && _ctx.viewOnExplorer(...args)))
                  }, [
                    _hoisted_34,
                    _createTextVNode(_toDisplayString(_ctx.$t("header.view-on-explorer")), 1)
                  ]),
                  _createElementVNode("li", {
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.disconnectWallet && _ctx.disconnectWallet(...args)))
                  }, [
                    _hoisted_35,
                    _createTextVNode(_toDisplayString(_ctx.$t("header.disconnect-wallet")), 1)
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.walletInfo]
              ])
            ])
          ]),
          _hoisted_36
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", {
        class: _normalizeClass(["mb-header", { back: _ctx.initIsBlack }])
      }, [
        _createElementVNode("h1", null, [
          _createElementVNode("img", {
            class: "sec-img",
            src: _imports_0,
            alt: "",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.clickLogo()))
          })
        ]),
        _createElementVNode("div", _hoisted_38, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "menuicon",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.foldHeader) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.foldHeader]
          ]),
          _hoisted_39,
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("h1", null, [
              _createElementVNode("img", {
                class: "sec-img",
                src: _imports_0,
                alt: "",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.clickLogo()))
              })
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.connectChecked('/agenda')))
                }, [
                  _createElementVNode("a", null, _toDisplayString(_ctx.$t("detail.voting")), 1)
                ]),
                _createElementVNode("li", {
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.connectChecked('/staking')))
                }, [
                  _createElementVNode("a", null, _toDisplayString(_ctx.$t("staking.staking")), 1)
                ]),
                _createElementVNode("li", {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.router.push('/forum')))
                }, [
                  _createElementVNode("a", null, _toDisplayString(_ctx.$t("header.forum")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", _hoisted_41, _toDisplayString(_ctx.$t("header.webtoon")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", _hoisted_42, _toDisplayString(_ctx.$t("header.nft-market")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", _hoisted_43, _toDisplayString(_ctx.$t("header.docs")), 1)
                ]),
                _createElementVNode("li", _hoisted_44, [
                  _createElementVNode("a", null, _toDisplayString(_ctx.$t("header.language")), 1),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        name: "currLang2",
                        id: "currLang2",
                        class: "mb-dropdown",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.foldLang2) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.foldLang2]
                      ]),
                      _createElementVNode("label", _hoisted_47, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.currentLanguage), 1),
                        _hoisted_48
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langs, (item, index) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: index,
                            onClick: ($event: any) => (_ctx.changeLanguage(item)),
                            class: _normalizeClass({ active: item.title === _ctx.currentLanguage })
                          }, _toDisplayString(item.title), 11, _hoisted_50))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", {
                class: _normalizeClass(["wallet", { wrong: _ctx.isWalletType === 1 }]),
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.connectMetaMask && _ctx.connectMetaMask(...args)))
              }, [
                _createElementVNode("p", _hoisted_52, [
                  _hoisted_53,
                  (_ctx.store.state.address === '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_54, "Connect"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_ctx.store.getters.getAddressEllipsis), 1))
                ])
              ], 2)
            ])
          ])
        ])
      ], 2)
    ]),
    _createVNode(_component_PopupOk, {
      initIsShowPopup: _ctx.popupOkShow,
      initPopupOkHeader: _ctx.popupOkHeader,
      initPopupOkMessage: _ctx.popupOkMessage,
      onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.close('PopupOk')))
    }, null, 8, ["initIsShowPopup", "initPopupOkHeader", "initPopupOkMessage"])
  ], 64))
}